export const Action = {
  Auth: {
    LoginRequested: 'Login',
    LoginCompleted: 'Login_FULFILLED',
    LoginPending: 'Login_PENDING',
    LogoutRequested: 'Logout',
    LoggedOut: 'Logout_FULFILLED',
  },
  Station: {
    SetStation: 'SET_STATION',
    EditStation: 'EDIT_STATION',
  },
  Loading: {
    SetLoading: 'SET_LOADING',
  },
  Brands: {
    SetBrands: 'SET_BRANDS',
  },
  DateRange: {
    SetDateRange: 'SET_DATE_RANGE',
  },
  ComparisonMetric: {
    SetComparisonMetric: 'SET_COMPARISON_METRIC',
  },
};

// Station Actions

export const setStation = station => ({
  type: Action.Station.SetStation,
  station,
});

export const editStation = stationEdit => ({
  type: Action.Station.EditStation,
  stationEdit,
});

// Loading Actions

export const setLoading = loading => ({
  type: Action.Loading.SetLoading,
  loading,
});

// All brands
export const setBrands = brands => ({
  type: Action.Brands.SetBrands,
  brands,
});

// Date Range
export const setDateRange = dateRange => ({
  type: Action.DateRange.SetDateRange,
  dateRange,
});

// Comparison Metric
export const setComparisonMetric = comparisonMetric => ({
  type: Action.ComparisonMetric.SetComparisonMetric,
  comparisonMetric,
});
